<template>
  <div>
    <div>
      <div class="main-wrapper">
        <div>
          <!-- <layout-header2></layout-header2> -->
          <layout-header></layout-header>
          <breadcrumb41></breadcrumb41>
          <!-- Page Content -->
          <div class="content">
            <div class="container">
              <div class="row">
                <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                  <sidebar></sidebar>
                </div>

                <div class="col-md-7 col-lg-8 col-xl-9" v-if="showspinner">
                  <loader></loader>
                </div>
                <div class="col-md-7 col-lg-8 col-xl-9 doctor-profile" v-else>
                  <i class="fa fa-arrow-left fa-lg ml-md-4" aria-hidden="true"
                    style="background-color:black; color:white;padding:10px;border-radius:100%; cursor: pointer;"
                    @click="goBack"></i>
                  <!-- Basic Information -->
                  <!-- <h3 class="mt-2 mb-3">Treatment Plan</h3> -->
                  <div class="card mt-2 ml-md-4">
                    <div class="card-body doctor-profile">
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Title of Plan</label>
                            <input type="text" class="form-control" v-model="new_treatment.treatment_plan_name"
                              placeholder="Title of Plan" oninput="this.value = this.value.replace(/[^a-zA-Z ]/g, ''); 
                              if (this.value.startsWith(' ')) this.value = this.value.trim();" />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Status</label>
                            <div class="m-1">
                              <input type="radio" value="Active" v-model="new_treatment.status" />&nbsp; Active

                              <input type="radio" value="Inactive" v-model="new_treatment.status" class="ml-5" />&nbsp;
                              Inactive
                            </div>
                          </div>
                        </div>
                        <!-- <div class="col-md-6">
                          <div class="form-group">
                            <label>Status</label>

                            <v-select placeholder="Status" v-model="new_treatment.status" :options="treatment_status">
                            </v-select>
                          </div>
                        </div> -->
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Prescription</label>
                            <v-select class="mr-2" name="name" required="" label="template_name"
                              placeholder="Select Template" v-model="new_treatment.medical_prescription"
                              :reduce="(option) => option.name" :options="all_prescription_template">
                            </v-select>
                            <div class="add-more text-left" style="margin-top: 10px;">
                              <a href="javascript:void(0);" class="add-reg" data-toggle="modal" data-target="#addtemplate"
                                @click="open_treament('Prescription')"><i class="fa fa-plus-circle"></i> New
                                Prescription Template</a>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Surgery Advice</label>
                            <v-select class="mr-2" name="name" required="" label="template_name"
                              placeholder="Select Template" v-model="new_treatment.surgery_advice"
                              :reduce="(option) => option.name" :options="all_surgery_template">
                            </v-select>
                            <div class="add-more text-left" style="margin-top: 10px;">
                              <a href="javascript:void(0);" class="add-reg" data-toggle="modal" data-target="#addtemplate"
                                @click="open_treament('Surgery')"><i class="fa fa-plus-circle"></i> New Surgery
                                Template</a>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Exercise Advice</label>
                            <v-select class="mr-2" name="name" required="" label="template_name"
                              v-model="new_treatment.exercise" placeholder="Select Template"
                              :reduce="(option) => option.name" :options="all_exercise_advice_template">
                            </v-select>
                            <div class="add-more text-left" style="margin-top: 10px;">
                              <a href="javascript:void(0);" class="add-reg" data-toggle="modal" data-target="#addtemplate"
                                @click="open_treament('Exercise')"><i class="fa fa-plus-circle"></i> New Exercise
                                Template</a>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Investigation Advice</label>
                            <v-select class="mr-2" name="name" required="" label="template_name"
                              v-model="new_treatment.investigation_advice" placeholder="Select Template"
                              :reduce="(option) => option.name" :options="all_investigation_template">
                            </v-select>
                            <div class="add-more text-left" style="margin-top: 10px;">
                              <a href="javascript:void(0);" class="add-reg" data-toggle="modal" data-target="#addtemplate"
                                @click="open_treament('Investigation')"><i class="fa fa-plus-circle"></i> New
                                Investigation Template</a>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>General Advice</label>
                            <v-select class="mr-2" name="name" required="" label="template_name"
                              v-model="new_treatment.general_advice" placeholder="Select Template"
                              :reduce="(option) => option.name" :options="all_general_advice_template">
                            </v-select>
                            <div class="add-more text-left" style="margin-top: 10px;">
                              <a href="javascript:void(0);" class="add-reg" data-toggle="modal" data-target="#addtemplate"
                                @click="open_treament('General')"><i class="fa fa-plus-circle"></i> New General
                                Advice Template</a>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Description</label>
                            <textarea rows="5" type="text" class="form-control" v-model="new_treatment.description"
                              placeholder="Description" />
                          </div>
                        </div>
                        <div class="ml-3">
                          <div class="submit-section text-left">
                            <button style="height: 40px;" @click="add_new_treatment()"
                              :disabled="disabled_template_button" class="btn btn-primary btn-sm mb-1">
                              Save Treatment Plan
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- /Basic Information -->
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Content -->
          <layout-footer></layout-footer>
        </div>
      </div>

      <div class="modal fade custom-modal show" id="addtemplate">
        <div class="modal-dialog modal-dialog-centered modal-md">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Add Template</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body doctor-profile">
              <div class="card">
                <div class="card-body">
                  <div class="row form-row">
                    <div class="col-12 col-md-12">
                      <div class="form-group">
                        <label>Template Name</label>
                        <input v-model="add_templates.template_name" type="text" class="form-control" value="" oninput="this.value = this.value.replace(/[^a-zA-Z ]/g, ''); 
                        if (this.value.startsWith(' ')) this.value = this.value.trim();" />
                      </div>
                    </div>
                    <div class="col-12 col-md-12" style="display: none;">
                      <div class="form-group">
                        <label>Category</label>
                        <v-select class="mr-2" required="" disabled v-model="add_templates.category"
                          placeholder="Select Category" :options="all_category">
                        </v-select>
                      </div>
                    </div>
                    <div class="col-12 col-md-12">
                      <div class="form-group testimonial">
                        <label>Description</label>
                        <ckeditor :editor="editor" v-model="add_templates.description"></ckeditor>
                      </div>
                    </div>
                  </div>
                  <div class="submit-section" style="text-align: left">
                    <button @click="add_new_templates()" :disabled="disabled_new_template_button"
                      class="btn btn-primary submit-btn" data-dismiss="modal" aria-label="Close">
                      Add Template
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonApi from "../../../services/CommonApi";
import { mapState } from "vuex";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
export default {
  components: {
    ckeditor: CKEditor.component,
  },
  data() {
    return {
      showspinner: false,
      disabled_template_button: true,
      disabled_new_template_button: true,
      editor: ClassicEditor,
      all_investigation_template: [],
      all_prescription_template: [],
      all_surgery_template: [],
      all_general_advice_template: [],
      all_exercise_advice_template: [],
      treatment_status: ["Active", "Inactive"],
      new_treatment: {
        treatment_plan_name: "",
        status: "Active",
        medical_prescription: "",
        surgery_advice: "",
        doctor: this.user_id,
        exercise: "",
        investigation_advice: "",
        general_advice: "",
        description: "",
      },
      add_templates: {
        category: "",
        template_name: "",
        description: "",
        doctor: this.user_id,
      },
      all_category: [],
    };
  },
  computed: {
    ...mapState({
      user_id: (state) => state.user.user_id,
    }),
    template_validation() {
      return (
        this.new_treatment.treatment_plan_name && this.new_treatment.status
      );
    },
    new_template_validation() {
      return (
        this.add_templates.category &&
        this.add_templates.template_name &&
        this.add_templates.description
      );
    },
  },
  watch: {
    template_validation() {
      if (
        this.new_treatment.treatment_plan_name === "" ||
        this.new_treatment.status === "" ||
        this.new_treatment.status === null
      ) {
        this.disabled_template_button = true;
      } else {
        this.disabled_template_button = false;
      }
    },

    new_template_validation() {
      if (
        this.add_templates.category === "" ||
        this.add_templates.category === null ||
        this.add_templates.template_name === "" ||
        this.add_templates.description === ""
      ) {
        this.disabled_new_template_button = true;
      } else {
        this.disabled_new_template_button = false;
      }
    },
  },
  methods: {

    goBack() {
      // Go one page back
      this.$router.go(-1);
    },
    /* Get All Investigation Template Plan  */
    async get_investigation_advice_templates() {
      const params = new URLSearchParams();
      params.append("doctor", this.user_id);
      await CommonApi.get_data(
        "sahaj.template.get_investigation_advice_templates",
        params
      ).then((res) => {
        this.showspinner = false;
        if (res && res.data) {
          this.all_investigation_template = res.data;
        }
      });
    },

    /* Get All Template Category  */
    async get_template_category() {
      await CommonApi.get_data("sahaj.template.get_template_category").then(
        (res) => {
          this.showspinner = false;
          if (res && res.message) {
            this.all_category = res.message;
          }
        }
      );
    },

    open_treament(type) {
      if (type === "Prescription") {
        this.add_templates.category = this.all_category[1];
      } else if (type === "Exercise") {
        this.add_templates.category = this.all_category[2];
      } else if (type === "General") {
        this.add_templates.category = this.all_category[3];
      } else if (type === "Surgery") {
        this.add_templates.category = this.all_category[4];
      } else if (type === "Investigation") {
        this.add_templates.category = this.all_category[5];
      }
    },

    /* Add New Template  */
    async add_new_templates() {
      this.$swal({
        text: "Adding Template...",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      await CommonApi.post_data(
        "sahaj.template.add_templates",
        this.add_templates
      ).then((res) => {
        this.showspinner = false;
        if (res && res.status_code === 200) {
          this.$swal.fire({
            icon: "success",
            title: "Success",
            text: res.message,
            showConfirmButton: true,
          });
          this.get_investigation_advice_templates();
          this.get_medical_prescription_templates_list();
          this.get_surgery_advice_templates();
          this.get_general_advice_templates_list();
          this.get_exercise_templates_list();
          this.$emit("close");
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: res.message,
            showConfirmButton: true,
          });
        }
        this.add_templates.category = "";
        this.add_templates.template_name = "";
        this.add_templates.description = "";
      });
    },

    /* Get All Prescription Template Plan  */
    async get_medical_prescription_templates_list() {
      const params = new URLSearchParams();
      params.append("doctor", this.user_id);
      await CommonApi.get_data(
        "sahaj.template.get_medical_prescription_templates_list",
        params
      ).then((res) => {
        this.showspinner = false;
        if (res && res.data) {
          this.all_prescription_template = res.data;
        }
      });
    },

    /* Get All Surgery Template Plan  */
    async get_surgery_advice_templates() {
      const params = new URLSearchParams();
      params.append("doctor", this.user_id);
      await CommonApi.get_data(
        "sahaj.template.get_surgery_advice_templates",
        params
      ).then((res) => {
        this.showspinner = false;
        if (res && res.data) {
          this.all_surgery_template = res.data;
        }
      });
    },

    /* Get All General Advice Template Plan   */
    async get_general_advice_templates_list() {
      const params = new URLSearchParams();
      params.append("doctor", this.user_id);
      await CommonApi.get_data(
        "sahaj.template.get_general_advice_templates_list",
        params
      ).then((res) => {
        this.showspinner = false;
        if (res && res.data) {
          this.all_general_advice_template = res.data;
        }
      });
    },

    /* Get All Exercise Advice Template Plan  */
    async get_exercise_templates_list() {
      const params = new URLSearchParams();
      params.append("doctor", this.user_id);
      await CommonApi.get_data(
        "sahaj.template.get_exercise_templates_list",
        params
      ).then((res) => {
        this.showspinner = false;
        if (res && res.data) {
          this.all_exercise_advice_template = res.data;
        }
      });
    },

    /* Add New Treatment  */
    async add_new_treatment() {
      this.new_treatment.doctor = this.user_id;
      await CommonApi.post_data(
        "sahaj.template.add_treatment_plan",
        JSON.stringify(this.new_treatment)
      ).then((res) => {
        this.showspinner = false;
        if (res && res.status_code === 200) {
          this.$swal.fire({
            icon: "success",
            title: "Success",
            text: res.message,
            showConfirmButton: true,
          }).then(() => {
            this.$router.push("/doctor/treatment-plan");
          });

          (this.new_treatment.treatment_plan_name = ""),
            (this.new_treatment.medical_prescription = ""),
            (this.new_treatment.surgery_advice = ""),
            (this.new_treatment.exercise = ""),
            (this.new_treatment.investigation_advice = "");
          this.new_treatment.general_advice = "";
          this.new_treatment.description = "";
        } else {
          this.$swal.fire({
            icon: "warning",
            title: "Warning",
            text: res.message,
            showConfirmButton: true,
          });
        }
      });
    },
  },
  mounted() {
    let user = localStorage.getItem("userInfo");
    if (!user) {
      this.$router.push({ name: 'login' })
    }
    this.get_investigation_advice_templates();
    this.get_medical_prescription_templates_list();
    this.get_surgery_advice_templates();
    this.get_general_advice_templates_list();
    this.get_exercise_templates_list();
    this.get_template_category();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/kneexpert/doctor/MyTreatmentPlan.vue